import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollToTopProps {
  children: React.ReactNode;
}

const ScrollToTop = ({ children }: ScrollToTopProps) => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.skipScrollToTop) {
      return undefined;
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.state?.skipScrollToTop]);

  return children;
};

export default ScrollToTop;
